import { injectable, Container } from 'inversify';
import { ImageService } from 'src/app/shared/image.service';
import { DocumentService } from 'src/app/shared/document.service';
import { PostcodeService } from '../core/services/postcode.service';
import { setup as accountingSetup } from './accounting/accounting.config';
import { setup as crmSetup } from './crm/crm.config';
import { setup as generalSetup } from './general/general.config';
import { setup as productSetup } from './products/products.config';
import { setup as bookingSetup } from './bookings/bookings.config';
import { setup as ruleSetup } from './rules/rules.config';
import { InitializeService } from 'src/app/shared/initialize.service';

export function setup(container: Container) {
	container.bind(DocumentService).toSelf().inSingletonScope();
	container.bind(ImageService).toSelf().inSingletonScope();
	container.bind(PostcodeService).toSelf().inSingletonScope();
	container.bind(InitializeService).toSelf().inSingletonScope();
	accountingSetup(container);
	crmSetup(container);
	generalSetup(container);
	productSetup(container);
	bookingSetup(container);
	ruleSetup(container);
}



// WEBPACK FOOTER //
// ./src/app/main.config.ts